import React from 'react'
import { Controller } from 'react-hook-form'

import { Grid, TextField } from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'

const ImplementForm = ({ isDisbled, formMethods }) => {
  const { control, errors } = formMethods

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Controller
          control={control}
          as={
            <TextField
              label="Evidência da implementação *"
              type="text"
              color="primary"
              variant="outlined"
              error={!!errors.implementEvidence}
              helperText={errors?.implementEvidence?.message}
              fullWidth
              disabled={isDisbled}
            />
          }
          name="implementEvidence"
          mode="onBlur"
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          as={
            <KeyboardDatePicker
              fullWidth
              format="DD/MM/yyyy"
              label="Data de realização"
              helperText={errors?.implementRealization?.message}
              error={!!errors.implementRealization}
              inputVariant="outlined"
              onChange={(newValue) => ({ value: newValue })}
              disabled={isDisbled}
            />
          }
          control={control}
          defaultValue={null}
          name="implementRealization"
          mode="onChange"
        />
      </Grid>
    </Grid>
  )
}

export default ImplementForm
